module.exports = __webpack_public_path__ + "static/media/aminities.7ecf8c79.svg";